import type {
  AvailableCalculationScenarios,
  CompletedCalculationTactic
} from './overmind/calculation';

export function hasLoadFlowCalculationDetails(
  availableCalculationScenarios: AvailableCalculationScenarios
) {
  const isLoadFlowVisible =
    (availableCalculationScenarios.type === 'SOME_AVAILABLE' &&
      availableCalculationScenarios.scenarios.has('LOAD_FLOW')) ||
    availableCalculationScenarios.type === 'ALL_AVAILABLE';
  return isLoadFlowVisible;
}

export function hasRawLoadFlowCalculations(
  calculationTactic: CompletedCalculationTactic
) {
  return (
    calculationTactic.calculationSetResult.calculationScenarios.loadFlow
      .length === 0
  );
}
